import { SetGetUsersList } from './thunk/setGetUsersList'

export const Thunks = {
    SetGetUsersList
}